import React, {
  Children,
  cloneElement,
  FC,
  ReactElement,
  MouseEventHandler,
  Dispatch,
} from "react";
import { useTabs } from "./TabContext";
import "../Tabs.scss";
import { TabsProps, TabProps } from "../Tabs.types";

export const Tabs: FC<TabsProps> = React.memo(
  ({ tabsPassedClass, children }) => {
    const childrenArray = Children.toArray(children).map((child, index) =>
      cloneElement(child as ReactElement, { id: `alteon-tab-${index}` })
    );
    return (
      <ul className={`alteon-tab-header ${tabsPassedClass}`}>
        {childrenArray}
      </ul>
    );
  }
);

export const Tab: FC<TabProps> = React.memo(
  ({
    tabPassedClass,
    id,
    children,
    onTabClick,
    isSelected,
    testid,
    ...props
  }) => {
    const { selectedTabIndex, setSelectedTabIndex } = useTabs();
    let className =
      selectedTabIndex === id
        ? "alteon-tab-trigger active"
        : "alteon-tab-trigger";

    if (typeof isSelected === "boolean") {
      className = isSelected
        ? "alteon-tab-trigger active"
        : "alteon-tab-trigger";
    }

    const clickHandler: MouseEventHandler<HTMLLIElement> = () => {
      (setSelectedTabIndex as Dispatch<React.SetStateAction<string>>)(
        id as string
      );
      if (onTabClick) {
        onTabClick();
      }
    };

    return (
      <li
        id={"tabs"}
        className={`${className} ${tabPassedClass} `}
        onClick={clickHandler}
        {...props}
        data-testid={testid}
      >
        {children}
      </li>
    );
  }
);
